import { Button, Typography } from "@material-tailwind/react";
import UbiCover from "../assets/images/ubi_1.jpg"

interface BannerProps {
  title: string
  subtitle?: string
}

export function Banner({ title, subtitle }: BannerProps) {
  return (
    <section className={`h-[280px] md:h-[380px] relative`} >
    <img
      alt="ubi_cover"
      className="h-full w-full object-cover object-center absolute inset-0 -z-20"
      src={UbiCover}
    />

    <div className="absolute inset-0 bg-gradient-to-b from-primary-600/80 to-primary-600/10 -z-10" ></div>
    <div className="flex flex-col justify-center items-center w-full h-full text-white z-20">
      <Typography variant="h1" className="mb-2">
       {title}
      </Typography>

      <Typography variant="h4" className="mb-2">
       {subtitle}
      </Typography>
    </div>

  </section>
  );
}
